import { useCallback, useEffect, useState } from "react";
import { campaignService } from "../../../services/companyAuthService";

/**
 * Loads campaigns for the pipeline campaign selector.
 */
export function useCompanyCampaignOptions() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await campaignService.getCampaigns();
      const list = res?.campaigns ?? res?.data ?? [];
      const mapped = Array.isArray(list)
        ? list.map((c) => ({
            id: String(c._id ?? c.id),
            name: c.name ?? "Untitled campaign",
            brandName:
              c.brandName ||
              (c.brand && (c.brand.brandName || c.brand.name)) ||
              "Your brand",
            status: c.status === "inactive" || c.status === "expired" ? c.status : "active",
            commission: c.commission ?? null,
          }))
        : [];
      if (mapped.length > 0) {
        setCampaigns(mapped);
      } else {
        setCampaigns([]);
      }
    } catch (e) {
      setError(e);
      setCampaigns([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { campaigns, loading, error, reload: load };
}
